import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
